import {
  HCAPTCHA_SITE_KEY_DEV,
  HCAPTCHA_SITE_KEY_PROD,
  HCAPTCHA_SITE_KEY_STAGING,
  PROD_ENVIRONMENTS_FOR_CAPTCHA,
  STAGING_ENVIRONMENTS_FOR_CAPTCHA,
} from 'constants/captcha';

let environment = '';
const encodedEnvironment = window.xprops?.env;

if (encodedEnvironment) {
  environment = atob(encodedEnvironment);
}

const getCaptchaKey = () => {
  if (PROD_ENVIRONMENTS_FOR_CAPTCHA.includes(environment)) {
    return HCAPTCHA_SITE_KEY_PROD;
  }
  if (STAGING_ENVIRONMENTS_FOR_CAPTCHA.includes(environment)) {
    return HCAPTCHA_SITE_KEY_STAGING;
  }
  return HCAPTCHA_SITE_KEY_DEV;
};

export const captchaKey = getCaptchaKey();
